.modal-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .modal-mantle {
    width: 100%;
    height: 100%;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.4);
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      transition: opacity 200ms ease-in-out;
      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      transition: opacity 200ms ease-in-out;
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }

  .modal-content-wrap {
    position: absolute;
    z-index: 10001;
    box-shadow: 0 0 32px rgba(0, 0, 0, 0.1);
    background: #fff;

    .modal-button-wrap {
      position: absolute;
      left: 0;
      bottom: 0px;
      z-index: 10002;
      width: 100%;
      padding: 16px 24px;
      background: #fff;
    }
  }

  .modal-content-desktop-wrap {
    width: 430px;
    border-radius: 16px;
    height: auto !important;
    top: 16px !important;
    bottom: 16px !important;
    display: flex;
    flex-direction: column;
    @at-root [dir='ltr'] & {
      right: 16px;
    }
    @at-root [dir='rtl'] & {
      left: 16px;
    }
    .modal-content {
      width: 100%;
      max-height: calc(100% - 80px);
      overflow-y: auto;
    }
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      @at-root [dir='ltr'] & {
        animation: xRSlideFrom .3s;
      }
      @at-root [dir='rtl'] & {
        animation: xLSlideFrom .3s;
      }

      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      @at-root [dir='ltr'] & {
        animation: xRSlideOut .3s;
      }
      @at-root [dir='rtl'] & {
        animation: xLSlideOut .3s;
      }
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }

  .modal-content-mobile-wrap {
    width: 100%;
    left: 0;
    bottom: 0;
    border-radius: 8px 8px 0 0;
    max-height: 90%;
    display: flex;
    flex-direction: column;
    .modal-content {
      max-height: calc(100vh - 100px);
      overflow-y: auto;
    }
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      animation: slideIn .3s;
      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      animation: slideOut .3s;
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }

  @keyframes slideIn {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
  }

  @keyframes slideOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(100%);
    }
  }

  @keyframes xRSlideFrom {
    0% {
        opacity: 0;
        transform: translateX(100%);
    }
    100% {
        opacity: 1;
        transform: translateX(0%);
    }
  }

  @keyframes xRSlideOut {
    0% {
        opacity: 1;
        transform: translateX(0);
    }
    100% {
        opacity: 0;
        transform: translateX(100%);
    }
  }

  @keyframes xLSlideFrom {
    0% {
        opacity: 0;
        transform: translateX(-100%);
    }
    100% {
        opacity: 1;
        transform: translateX(0%);
    }
  }

  @keyframes xLSlideOut {
    0% {
        opacity: 1;
        transform: translateX(0);
    }
    100% {
        opacity: 0;
        transform: translateX(-100%);
    }
  }
}
